/* Douglas — sliders (banner rotativo + carrosséis horizontais) */
(function () {
  function initBannerSliders(scope) {
    scope.querySelectorAll('[data-slider]').forEach(function (root) {
      if (root.dataset.sliderReady) return;
      root.dataset.sliderReady = '1';

      var track = root.querySelector('.banner-slider--slides');
      var slides = root.querySelectorAll('.banner-slider--item');
      var dots = root.querySelectorAll('.slider--dots button');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var delay = parseInt(root.dataset.autoplay, 10) || 0;
      var i = 0;
      var timer;

      if (slides.length < 2) {
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
        return;
      }

      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        dots.forEach(function (d, x) {
          if (x === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
      }
      function play() { stop(); if (delay > 0) timer = setInterval(function () { go(i + 1); }, delay); }
      function stop() { if (timer) clearInterval(timer); }

      if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
      if (next) next.addEventListener('click', function () { go(i + 1); play(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.go); play(); }); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      play();
    });
  }

  function initScrollers(scope) {
    scope.querySelectorAll('[data-scroller]').forEach(function (root) {
      if (root.dataset.scrollerReady) return;
      root.dataset.scrollerReady = '1';

      var track = root.querySelector('[data-track]');
      var arrows = root.querySelectorAll('[data-scroll]');
      if (!track) return;

      function sync() {
        var over = track.scrollWidth - track.clientWidth > 2;
        arrows.forEach(function (b) {
          var dir = +b.dataset.scroll;
          var atEnd = dir > 0
            ? track.scrollLeft >= track.scrollWidth - track.clientWidth - 2
            : track.scrollLeft <= 2;
          b.style.visibility = (over && !atEnd) ? 'visible' : 'hidden';
        });
      }
      arrows.forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: (+b.dataset.scroll) * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* Galeria do produto: miniatura troca a imagem principal */
  function initGallery(scope) {
    var main = scope.querySelector('#ProductMainImage');
    var thumbs = scope.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      if (btn.dataset.thumbReady) return;
      btn.dataset.thumbReady = '1';
      btn.addEventListener('click', function () {
        main.src = btn.dataset.thumb;
        thumbs.forEach(function (b) { b.classList.remove('is--active'); });
        btn.classList.add('is--active');
      });
    });
  }

  /* Seletor de variante: atualiza preço e imagem sem recarregar */
  function initVariants(scope) {
    var select = scope.querySelector('[data-variant-select]');
    if (!select || select.dataset.variantReady) return;
    select.dataset.variantReady = '1';

    var priceEl = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare-price]');
    var main = scope.querySelector('#ProductMainImage');
    var submit = scope.querySelector('#ProductForm button[type="submit"]');

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;

      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        var hasCompare = opt.dataset.compare && opt.dataset.compare !== opt.dataset.price;
        compareEl.textContent = hasCompare ? opt.dataset.compare : '';
        compareEl.hidden = !hasCompare;
        if (priceEl) priceEl.classList.toggle('is--discount', !!hasCompare);
      }
      if (main && opt.dataset.image) main.src = opt.dataset.image;
      if (submit) {
        var available = opt.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Adicionar ao cesto' : 'Esgotado';
      }
    });
  }

  /* Confirmação antes de eliminar uma morada */
  function initConfirms(scope) {
    scope.querySelectorAll('[data-confirm-delete]').forEach(function (el) {
      if (el.dataset.confirmReady) return;
      el.dataset.confirmReady = '1';
      el.addEventListener('click', function (e) {
        if (!window.confirm('Eliminar esta morada?')) e.preventDefault();
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    initBannerSliders(scope);
    initScrollers(scope);
    initGallery(scope);
    initVariants(scope);
    initConfirms(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Editor de temas: re-inicializa a secção recarregada */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
